import {ProductIngredientGenqlSelection} from "@/gql/gen";

export const ProductIngredientFields: ProductIngredientGenqlSelection = {
    ID: true,
    NAME: true,
    PROPERTIES: {
        SHOW_IN_FILTER: true,
    },
}
